// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import { Card, CardTitle, CardBody, Button, Input, Table } from 'reactstrap';
// import VendorBranchSelector from '../../components/VendorBranchSelector';
// import { useSelector } from 'react-redux';
// import { toast } from 'react-toastify';

// const StudentPaymentList = () => {
//   const navigate = useNavigate();
//   const { user } = useSelector((state) => state.authState);

//   const isStudent =
//     String(user?.user_profile || '').toLowerCase() === 'student';

//   const [paymentList, setPaymentList] = useState([]);
//   const [errorMessage, setErrorMessage] = useState({});
//   const [selectionData, setSelectionData] = useState({
//     vendor_id: '',
//     branch_id: '',
//   });
//   const [searchText, setSearchText] = useState('');

//   const getFileUrl = useCallback((path) => {
//     if (!path) return '';
//     if (/^https?:\/\//i.test(path)) return path;
//     return (process.env.REACT_APP_API_BASE_URL || '') + path;
//   }, []);

//   const formatDate = (value) => {
//     if (!value) return '-';
//     const d = new Date(value);
//     if (Number.isNaN(d.getTime())) return value;
//     return d.toLocaleDateString();
//   };

//   const onHandleView = (id) => {
//     navigate('/student-payment-view', { state: { id } });
//   };

//   const loadPayments = useCallback(async () => {
//     try {
//       const params = new URLSearchParams();

//       if (isStudent) {
//         params.append('myOnly', 'true');
//       } else {
//         if (selectionData.vendor_id) {
//           params.append('vendorId', selectionData.vendor_id);
//         }

//         if (selectionData.branch_id) {
//           params.append('branchId', selectionData.branch_id);
//         }
//       }

//       if (searchText?.trim()) {
//         params.append('search', searchText.trim());
//       }

//       const res = await apiService.get(
//         `api/StudentPayment/get-payment?${params.toString()}`,
//       );

//       if (res?.status === true) {
//         setPaymentList(res.data || []);
//       } else {
//         toast.error(res?.message || 'Failed');
//         setPaymentList([]);
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error('Something went wrong');
//       setPaymentList([]);
//     }
//   }, [isStudent, selectionData.vendor_id, selectionData.branch_id, searchText]);

//   useEffect(() => {
//     const t = setTimeout(() => {
//       loadPayments();
//     }, 300);

//     return () => clearTimeout(t);
//   }, [loadPayments]);

//   return (
//     <>
//       {!isStudent && (
//         <VendorBranchSelector
//           user={user}
//           selectionData={selectionData}
//           setSelectionData={setSelectionData}
//           errorMessage={errorMessage}
//           accessButton={true}
//         />
//       )}

//       <Card className='card-box pd-20 mb-20'>
//         <CardTitle className='p-3 d-flex justify-content-between align-items-center'>
//           <span>
//             <i className='bi bi-credit-card mr-2' />{' '}
//             {isStudent ? 'All Payment' : 'Student Payment Details'}
//           </span>

//           {isStudent && (
//             <Button
//               color='primary'
//               onClick={() => navigate('/save-student-payment')}
//             >
//               Add Payment
//             </Button>
//           )}
//         </CardTitle>

//         <div
//           className='col-12 d-flex justify-content-center'
//           style={{ padding: '0 10px' }}
//         >
//           <Input
//             id='search'
//             name='search'
//             placeholder='Search...'
//             type='text'
//             value={searchText}
//             onChange={(e) => setSearchText(e.target.value)}
//             className='mx-auto'
//           />
//         </div>

//         <CardBody>
//           <Table striped hover responsive>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>View</th>
//                 <th>Image</th>
//                 <th>Enrollment ID</th>
//                 <th>Student Name</th>
//                 <th>Batch Name</th>
//                 <th>Session Year</th>
//                 <th>Amount</th>
//                 <th>Verified</th>
//                 <th>Remarks</th>
//                 <th>Date</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paymentList.length > 0 ? (
//                 paymentList.map((item, index) => {
//                   const fileUrl = getFileUrl(item.img_url);

//                   return (
//                     <tr key={item.id}>
//                       <td>{index + 1}</td>

//                       <td>
//                         <Button
//                           color='info'
//                           size='sm'
//                           onClick={() => onHandleView(item.id)}
//                         >
//                           View
//                         </Button>
//                       </td>

//                       <td>
//                         {fileUrl ? (
//                           <a href={fileUrl} target='_blank' rel='noreferrer'>
//                             <img
//                               alt='student'
//                               style={{
//                                 width: 70,
//                                 height: 50,
//                                 borderRadius: 6,
//                                 objectFit: 'cover',
//                                 border: '1px solid #ddd',
//                               }}
//                               src={fileUrl}
//                               onError={(e) => {
//                                 e.currentTarget.style.display = 'none';
//                               }}
//                             />
//                           </a>
//                         ) : (
//                           <span>-</span>
//                         )}
//                       </td>

//                       <td>{item.enrollment_id || '-'}</td>
//                       <td>{item.stud_name || '-'}</td>
//                       <td>{item.batch_name || '-'}</td>
//                       <td>{item.session_year || '-'}</td>
//                       <td>{item.amount ?? '-'}</td>
//                       <td>{item.verified ? 'Yes' : 'No'}</td>
//                       <td>{item.remarks || '-'}</td>
//                       <td>{formatDate(item.created_on)}</td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan='11' className='text-center'>
//                     No data available
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default StudentPaymentList;
//SignalR
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import {
  Card,
  CardTitle,
  CardBody,
  Button,
  Input,
  Table,
  Badge,
} from 'reactstrap';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  createAppConnection,
  joinModuleGroup,
  leaveModuleGroup,
  subscribeRealtimeUpdate,
  unsubscribeRealtimeUpdate,
} from '../../utils/signalRService';

const MODULE_NAME = 'StudentPayment';

const StudentPaymentList = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.authState || {});

  const isStudent =
    String(user?.user_profile || '').toLowerCase() === 'student';

  const [paymentList, setPaymentList] = useState([]);
  const [errorMessage, setErrorMessage] = useState({});
  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });
  const [searchText, setSearchText] = useState('');

  const currentGroupRef = useRef({
    module: null,
    vendorId: null,
    branchId: null,
  });

  const getFileUrl = useCallback((path) => {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    return (process.env.REACT_APP_API_BASE_URL || '') + path;
  }, []);

  const formatDate = (value) => {
    if (!value) return '-';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleDateString();
  };

  const onHandleView = (id) => {
    navigate('/student-payment-view', { state: { id } });
  };

  const loadPayments = useCallback(async () => {
    try {
      const params = new URLSearchParams();

      let vendorId = selectionData.vendor_id || '';
      let branchId = selectionData.branch_id || '';

      if (isStudent) {
        params.append('myOnly', 'true');

        vendorId = user?.vendor_id || user?.VendorID || '';
        branchId = user?.branch_id || user?.BranchID || '';
      } else {
        if (vendorId) params.append('vendorId', vendorId);
        if (branchId) params.append('branchId', branchId);
      }

      if (searchText?.trim()) {
        params.append('search', searchText.trim());
      }

      const res = await apiService.get(
        `api/StudentPayment/get-payment?${params.toString()}`,
      );

      if (res?.status === true) {
        setPaymentList(res.data || []);
      } else {
        toast.error(res?.message || 'Failed');
        setPaymentList([]);
      }
    } catch (error) {
      console.error(error);
      toast.error('Something went wrong');
      setPaymentList([]);
    }
  }, [
    isStudent,
    selectionData.vendor_id,
    selectionData.branch_id,
    searchText,
    user,
  ]);

  useEffect(() => {
    const t = setTimeout(() => {
      loadPayments();
    }, 300);

    return () => clearTimeout(t);
  }, [loadPayments]);

  useEffect(() => {
    let mounted = true;

    const setupSignalR = async () => {
      try {
        await createAppConnection();

        const vendorId = isStudent
          ? user?.vendor_id || user?.VendorID || 0
          : selectionData.vendor_id || 0;

        const branchId = isStudent
          ? user?.branch_id || user?.BranchID || 0
          : selectionData.branch_id || 0;

        const prev = currentGroupRef.current;

        if (
          prev.vendorId &&
          prev.branchId &&
          (String(prev.vendorId) !== String(vendorId) ||
            String(prev.branchId) !== String(branchId))
        ) {
          await leaveModuleGroup(prev.module, prev.vendorId, prev.branchId);
        }

        if (vendorId && branchId) {
          await joinModuleGroup(MODULE_NAME, vendorId, branchId);

          currentGroupRef.current = {
            module: MODULE_NAME,
            vendorId,
            branchId,
          };
        }

        unsubscribeRealtimeUpdate();

        await subscribeRealtimeUpdate((payload) => {
          if (!mounted || !payload) return;

          const isSameModule = String(payload.module || '') === MODULE_NAME;

          const isSameVendor =
            String(payload.vendorId || '') === String(vendorId || '');

          const isSameBranch =
            String(payload.branchId || '') === String(branchId || '');

          if (isSameModule && isSameVendor && isSameBranch) {
            loadPayments();
          }
        });
      } catch (err) {
        console.error('SignalR error:', err);
      }
    };

    setupSignalR();

    return () => {
      mounted = false;
    };
  }, [
    isStudent,
    selectionData.vendor_id,
    selectionData.branch_id,
    user,
    loadPayments,
  ]);

  useEffect(() => {
    return () => {
      unsubscribeRealtimeUpdate();

      const prev = currentGroupRef.current;
      if (prev?.vendorId && prev?.branchId) {
        leaveModuleGroup(prev.module, prev.vendorId, prev.branchId).catch(
          console.error,
        );
      }
    };
  }, []);

  return (
    <>
      {!isStudent && (
        <VendorBranchSelector
          user={user}
          selectionData={selectionData}
          setSelectionData={setSelectionData}
          errorMessage={errorMessage}
          accessButton={true}
        />
      )}

      <Card className='card-box pd-20 mb-20'>
        <CardTitle className='p-3 d-flex justify-content-between align-items-center'>
          <span>
            <i className='bi bi-credit-card mr-2' />{' '}
            {isStudent ? 'All Payment' : 'Student Payment Details'}
          </span>

          {isStudent && (
            <Button
              color='primary'
              onClick={() => navigate('/save-student-payment')}
            >
              Add Payment
            </Button>
          )}
        </CardTitle>

        <div
          className='col-12 d-flex justify-content-center'
          style={{ padding: '0 10px' }}
        >
          <Input
            id='search'
            name='search'
            placeholder='Search...'
            type='text'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className='mx-auto'
          />
        </div>

        <CardBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Date</th>

                <th>Image</th>
                {!isStudent && <th>Enrollment ID</th>}
                {!isStudent && <th>Student Name</th>}
                {!isStudent && <th>Batch Name</th>}
                <th>Session Year</th>
                <th>Amount</th>
                <th>Verified</th>
                <th>Remarks</th>
                <th>View</th>
              </tr>
            </thead>

            <tbody>
              {paymentList.length > 0 ? (
                paymentList.map((item, index) => {
                  const fileUrl = getFileUrl(item.img_url);

                  return (
                    <tr key={item.id}>
                      <td>{index + 1}</td>

                      <td>{formatDate(item.created_on)}</td>

                      <td>
                        {fileUrl ? (
                          <a href={fileUrl} target='_blank' rel='noreferrer'>
                            <img
                              alt='student'
                              style={{
                                width: 70,
                                height: 50,
                                borderRadius: 6,
                                objectFit: 'cover',
                                border: '1px solid #ddd',
                              }}
                              src={fileUrl}
                              onError={(e) => {
                                e.currentTarget.style.display = 'none';
                              }}
                            />
                          </a>
                        ) : (
                          <span>-</span>
                        )}
                      </td>

                      {!isStudent && <td>{item.enrollment_id || '-'}</td>}
                      {!isStudent && <td>{item.stud_name || '-'}</td>}
                      {!isStudent && <td>{item.batch_name || '-'}</td>}

                      <td>{item.session_year || '-'}</td>
                      <td>{item.amount || '-'}</td>

                      <td>
                        <Badge
                          color={item.verified ? 'success' : 'danger'}
                          pill
                        >
                          {item.verified ? 'Yes' : 'No'}
                        </Badge>
                      </td>

                      <td>{item.remarks || '-'}</td>

                      <td>
                        <Button
                          color='info'
                          size='sm'
                          onClick={() => onHandleView(item.id)}
                        >
                          View
                        </Button>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={isStudent ? 8 : 11} className='text-center'>
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  );
};

export default StudentPaymentList;
